import React from 'react';
import styled from 'styled-components';
import MsxIcons from '../../msx-icons';


const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 1000;
  transition: opacity 250ms;
  opacity: ${props => (props.$show ? 1 : 0)};
  ${props => (props.$show ? '' : 'pointer-events: none;')}
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  width: 100%;
  height: 66%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 250ms;
  transform: ${props => (props.$show ? 'translateY(0)' : 'translateY(100%)')};
`;

const Title = styled.div`
  display: flex;
  font-size: 19px;
  font-weight: bold;
`;

const CloseButton = styled.div`
  cursor: pointer;
  color: #626469;
`;

const TextWrapper = styled.div`
  display: flex;
  margin-bottom: 10px;
  margin-top: 20px;
  white-space: pre-wrap;
  padding: 20px;
  flex-grow: 1;
`;

const DescriptionModal = ({ text, title, show, onClose }) => (

  <ModalWrapper $show={show}>
    <ModalContent $show={show}>
      <HeaderWrapper>
        <Title>{title}</Title>
        <CloseButton onClick={onClose}>
          <MsxIcons name="close"></MsxIcons>
        </CloseButton>
      </HeaderWrapper>
      <TextWrapper>{text}</TextWrapper>
    </ModalContent>
  </ModalWrapper>
);

export default DescriptionModal;
